module.exports = __webpack_public_path__ + "static/media/right_distortion.b950e6d6.png";